// O que o navegador não pode gravar em weddings/{uid}. A apiKeyEnc também
// sai do estado do React: o snapshot do doc ainda pode trazê-la até o strip,
// mas a tela não fica com ela.

export const CLIENT_BLOCKED_WEDDING_KEYS = Object.freeze([
  'payout',
  'asaas',
  'referralCredit',
  'referralTotalEarned',
  'referralTotalSavings',
  'referralLastCreditedAt',
  'phone',
  'email',
  'feeNominalValue',
  'feeAppliedValue',
  'feeNominalPercent',
  'feeAppliedPercent',
  'referralCreditUsed',
  'platformFee',
]);

const FINANCE_OVERLAY_KEYS = [
  'referralCredit',
  'referralTotalEarned',
  'referralTotalSavings',
  'referralLastCreditedAt',
  'phone',
  'email',
];

export function omitBlockedWeddingKeys(updates) {
  const out = { ...(updates || {}) };
  for (const key of CLIENT_BLOCKED_WEDDING_KEYS) delete out[key];
  return out;
}

export function stripApiKey(wedding) {
  if (!wedding || typeof wedding !== 'object') return wedding;
  if (!wedding.asaas || typeof wedding.asaas !== 'object') return wedding;
  const asaas = { ...wedding.asaas };
  delete asaas.apiKeyEnc;
  return { ...wedding, asaas };
}

export function overlayFinance(wedding, finance) {
  const base = stripApiKey(wedding) || wedding;
  if (!base || !finance || typeof finance !== 'object') return base;
  const next = { ...base };
  if (finance.payout && typeof finance.payout === 'object') next.payout = finance.payout;
  if (finance.asaas && typeof finance.asaas === 'object') {
    const asaas = { ...finance.asaas };
    delete asaas.apiKeyEnc;
    next.asaas = asaas;
  }
  for (const key of FINANCE_OVERLAY_KEYS) {
    if (finance[key] !== undefined) next[key] = finance[key];
  }
  if (finance.creditReview && typeof finance.creditReview === 'object') next.creditReview = finance.creditReview;
  if (finance.credentialHold && typeof finance.credentialHold === 'object') next.credentialHold = finance.credentialHold;
  return next;
}
